<template>
  <div class="report-bd">

    <div class="table-container">
      <div class="header">
        <div class="search-content">
          <el-form :inline="true" @submit.native.prevent>
            <el-radio-group v-model="formSearch.isGroupByProductCode" @change="onTypeChange">
              <el-radio-button :label="item.value" v-for="(item, index) in reportTypeData" :key="index">{{ item.label }}</el-radio-button>
            </el-radio-group>
            <el-form-item style="float: right; margin-right: 0">
              <custom-column ref="column"></custom-column>
            </el-form-item>
            <el-form-item
              style="float: right"
              v-if="funcView.runLog_department_export"
            >
              <el-button
                type="info"
                @click="onExport"
              >
                <i class="icon icon-export-excel"></i>
                {{ $t('Common.com_export') }}
              </el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
            </el-form-item>
            <el-form-item style="float: right">
              <el-date-picker
                v-model="reportMonthTime"
                type="monthrange"
                range-separator="—"
                :format="$getElFormat('yyyy-MM', true)"
                value-format="yyyy-MM"
                align="right"
                placeholder=""
                :picker-options="pickerOptionsIntervalThreeYears"
                :clearable="false"
                @change="onTypeChange"
                :start-placeholder="$t('Common.com_start_month')"
                :end-placeholder="$t('Common.com_end_month')"
              ></el-date-picker>
            </el-form-item>
         </el-form>

        </div>
      </div>
      <div class="query-filter" >
        <div class="params-form" v-show="isFilter">
          <el-row :gutter="23">
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('Common.com_belong_to_department') }}</div>
                <div class="value">
                  <custom-select
                    url="DepartmentTree"
                    v-model="formSearch.departmentId"
                    :model="formSearch"
                    :props="{ label: 'bizName', value: 'bizId',checkStrictly: true,map: { bizName: 'departmentName' } }"
                    :params="{ isCountDevice:1 }"
                    :placeholder="$t('Common.com_please_select')"
                    width="100%"
                    ref="tag"
                    type="tree"
                    filterable
                    :dataFilter="departmentTreeFilter"
                    @treeValChange="onPageChange({ page: 1 })"
                    @treeValChangeLabel="onDepartmentLabel"
                    @getList="onDepartmentList"
                    :clearable="false"
                  ></custom-select>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('Common.com_filter_item') }}</div>
          <div class="values">

            <!-- 时间 -->
            <el-tag
              v-if="formSearch.beginReportDate && formSearch.endReportDate"
              @close="
                reportMonthTime = [];
                onTypeChange();
              "
            >
              {{ formSearch.beginReportDate }}-{{ formSearch.endReportDate }}
            </el-tag>
            <el-tag
              v-if="formSearch.departmentId"
              closable
              @close="
                formSearch.departmentId = '';
                formSearch.departmentName = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.departmentName }}
            </el-tag>
            <span
              class="clear"
              @click="onClear"
            >{{ $t('Common.com_clear') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="table-bd">
      <!-- {{ tableList }} -->
      <custom-table
        v-if="isUs"
        tableCode="portal_department_log_all_ft"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        :slots="['totalCleanArea','averageCleanArea','actualCleanArea','attendanceRate']"
        @sort="sortChange"
        :filterArr="formSearch.isGroupByProductCode ? ['locationNum'] : ['productCode']"
        @filter="filterChange"
      >
        <!--
          totalCleanArea
          averageCleanArea
          actualCleanArea
          attendanceRate
        -->
        <template v-slot:totalCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.totalCleanArea)}}</span>
        </template>
        <template v-slot:averageCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.averageCleanArea)}}</span>
        </template>
        <template v-slot:actualCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.actualCleanArea)}}</span>
        </template>
        <template v-slot:attendanceRate="scope">
            <span :style="getCleanScoreColor(scope.row.attendanceRate)">{{scope.row.attendanceRate}}</span>
        </template>
      </custom-table>
      <custom-table
        v-if="!isUs"
        tableCode="portal_department_log_all"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        @sort="sortChange"
        @filter="filterChange"
        :filterArr="!!formSearch.isGroupByProductCode ? ['locationNum'] : ['productCode']"
        :slots="['attendanceRate']"
      >
        <template v-slot:attendanceRate="scope">
            <span :style="getCleanScoreColor(scope.row.attendanceRate)">{{scope.row.attendanceRate}}</span>
        </template>
      </custom-table>

    </div>
    <div class="page-footer">
        <custom-pagination
          :radius="false"
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-pagination>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';

export default {
  name: 'report',
  mixins: [],

  computed: {
    reportTypeData() {
      return [
        {
          label: this.$t('Common.com_all'),
          value: false,
        },
        {
          label: this.$t('department_log.xing_hao'),
          value: true,
        },
      ];
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    orgId() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.rootOrgId : '';
    },
    // 选择日期配置
    pickerOptionDisAfter() {
      return {
        shortcuts: [
          {
            text: this.$t('department_log.zui_jin_yi_zhou'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('department_log.zui_jin_yi_ge_yue'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('department_log.zui_jin_san_ge_yue'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
        disabledDate: time => moment(time).isAfter(this.$getLocalTime(), 'day'),
      };
    },
  },
  data() {
    return {
      provide: true,
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        isGroupByProductCode: false,
        orgId: '',
        departmentId: '',
        departmentName: ''

      },
      tagId: '',
      tags: [],
      // 日
      reportMonthTime: [`${moment(this.$getLocalTime()).add('month').format('YYYY-MM')}`, `${moment().add('month').format('YYYY-MM')}`],
      tableList: [],
      totalRows: 0,
      link: null,
      exporting: false,
      isFilter: false,
    };
  },

  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    // this.formSearch.beginReportDate = this.dateTimes ? this.dateTimes[0] : '';
    // this.formSearch.endReportDate = this.dateTimes ? this.dateTimes[1] : '';
    // this.mergeLanguage();
    this.onTypeChange();
  },
  methods: {
    // 获取列表
    getTableList() {
      this.$getJSON(apis.DeptDevicePage, { ...this.formSearch,
        orgId: this.formSearch.orgId ? this.formSearch.orgId : this.orgId,
        beginReportDate: this.formSearch.beginReportDate.replace(/-/g, ''),
        endReportDate: this.formSearch.endReportDate.replace(/-/g, ''),
        departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
        multiple: ''
      })
        .then((res) => {
          const data = res.data.list;
          this.nullValueToCrossbar(data, ['assistCount', 'orderCharged']);
          this.tableList = data;
          this.totalRows = res.data.total;
        })
        .catch(() => {
          this.tableList = [];
        });

    },
    // 获取季度

    onTypeChange() {
      this.formSearch.beginReportDate = this.reportMonthTime ? this.reportMonthTime[0] : '';
      this.formSearch.endReportDate = this.reportMonthTime ? this.reportMonthTime[1] : '';
      this.onPageChange({ page: 1 });
    },
    onClear() {
      this.formSearch.isGroupByProductCode = true;
      this.formSearch.departmentId = '';
      this.formSearch.departmentName = '';
      this.reportMonthTime = [`${moment(this.$getLocalTime()).add('month').format('YYYY-MM')}`, `${moment().add('month').format('YYYY-MM')}`];
      this.onTypeChange();
    },
    onExport: function () {
      this.exporting = true;
      this.exportTable('DeptDeviceExport', { ...this.formSearch,
        orgId: this.formSearch.orgId ? this.formSearch.orgId : this.orgId,
        beginReportDate: this.formSearch.beginReportDate.replace(/-/g, ''),
        endReportDate: this.formSearch.endReportDate.replace(/-/g, ''),
        departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
        multiple: '',
        excludeColumnList: this.formSearch.isGroupByProductCode ? ['locationNum'] : ['productCode'],
        platform: 'isynergy' }).then(() => {
        this.exporting = false;
      }).catch(() => {
        this.exporting = false;
      });

    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    dataFilterTree: function (list, code) {
      // 要过滤第一层 那children那层
      if (list.length > 0 && list[0].code === code) {
        const node = list[0];
        return node && node.children ? node.children : [];
      } else {
        return list;
      }
    },
    getCleanScoreColor(rate) {
    // 提取百分比值中的数字部分
      const value = parseFloat(rate);
      if (typeof value !== 'number') {
        return {};
      }
      // 根据条件返回不同的颜色样式
      if (value >= 90) {
        return { color: '#4CAF50' }; // 绿色
      } else if (value >= 70 && value < 90) {
        return { color: '#FFC107' }; // 黄色
      } else {
        return { color: '#F44336' }; // 红色
      }
    },
    departmentTreeFilter(obj) {
      const ret = [obj];
      const ret2 = this.removeEmptyChildren(ret);
      return ret2;
    },
    removeEmptyChildren(nodes) {
      return nodes.map((item) => {
        // 如果 children 存在且是空数组，则删除 children 属性
        if (Array.isArray(item.children) && item.children.length === 0) {
          const newItem = { ...item }; // 创建一个新的对象，避免直接修改原数据
          delete newItem.children; // 删除 children 属性
          return newItem; // 返回没有 children 属性的对象
        }

        // 如果有子节点，递归调用 removeEmptyChildren
        if (item.children && item.children.length > 0) {
          return { ...item, children: this.removeEmptyChildren(item.children) };
        }
        return item; // 其他情况直接返回
      });
    },
    onDepartmentList(list) {
      this.departmentList = list;
    },
    onDepartmentLabel(Label) {
      this.formSearch.departmentName = Label;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.report-bd {
  .table-container {
    border-radius: 16px;
    background: #fff;
    width: 100%;

    padding: 24px;
    // padding-bottom: 0;
    .el-radio-button:first-child .el-radio-button__inner {
      border-radius: 20px 0 0 20px;
    }

    .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0 20px 20px 0;
    }
    .icon-filter {
      display: inline-block;
      text-align: center;
      box-sizing: border-box;
      font-size: 14px;
      width: 40px;
      height: 40px;
      color: $--color-text-primary;
      box-shadow: 0 0 0 1.5px #202945 inset;
      border-radius: 50px;
      cursor: pointer;
    }
    .query-filter {
      padding: 0;
      .select-date {
        .el-input__prefix,
        .el-date-editor .el-range__icon {
          color: $--color-primary;
          font-size: 18px;
          margin-right: 8px;
        }
        input {
          font-weight: bold;
        }
        .el-input .el-input__inner {
          cursor: pointer;
          height: 48px;
          line-height: 48px;
          padding-left: 34px;
          font-weight: bold;
          color: $--color-text-primary;
          text-align: center;
        }
        .el-input__icon :after {
          font-family: 'icon' !important;
          content: '\E7F8';
          font-size: 22px;
          color: $--color-warning;
          margin-bottom: 2px;
        }
        // .el-range__close-icon.el-input__icon:after {
        //   font-family: 'icon' !important;
        //   content: '\E7F8';
        //   font-size: 22px;
        //   line-height: 42px;
        //   margin-right: 30px;
        //   color: $--color-warning;
        // }
        .el-input__icon.el-range__icon.el-icon-date {
          color: $--color-primary;
          font-size: 18px;
          margin-top: 2px;
        }
        .el-input .el-input__inner {
          cursor: pointer;
          height: 48px;
          line-height: 48px;
          padding-left: 34px;
          font-weight: bold;
          color: $--color-text-primary;
        }
      }
    }
    .week-picker,
    .season-picker,
    .year-picker {
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 47% !important;
        &:last-of-type {
          float: right;
        }
      }
      // i {
      //   flex: 1;
      //   text-align: center;
      // }
    }

    .season-picker {
      display: flex;
      justify-content: space-between;
      .quarter-picker {
        width: 47% !important;
        .el-input {
          width: 100% !important;
        }
        &:last-of-type {
          float: right;
        }
      }
      // i {
      //   flex: 1;
      //   text-align: center;
      // }
    }

    .search-content {
      overflow: hidden;

      .filter {
        width: 40px;
        height: 40px;
        border-radius: 100%;
        box-shadow: 0 0 0 1.5px #202945 inset;
        line-height: 40px;
        text-align: center;
        .icon {
          font-size: 16px;
          color: #202945;
        }
      }
    }
  }

  .table-bd {
    height: 550px;
  }
  .page-footer {
    height: 88px;
  }
}

</style>
